import React from 'react'
import { Box, Typography } from '@mui/material'
import EngineeringIcon from '@mui/icons-material/Engineering'
import * as sxStyles from './UiPages.style'

interface IUnavailablePageProps {}

export const UnavailablePage: React.FC<IUnavailablePageProps> = ({}) => {
  return (
    <Box sx={sxStyles.unavailablePageBox}>
      <Typography sx={sxStyles.unavailablePageTypograpgy}>
        This page is not available in this version
      </Typography>
      <EngineeringIcon sx={sxStyles.unavailablePageIcon} />
    </Box>
  )
}
